import { Input } from '@/src/components/ui/input'
import { AdminModal, AdminModalContent, AdminModalFooter, AdminModalHeader, AdminModalMiddle, AdminModalTitle } from '@/src/pages/admin/components/modal'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import useFormValidatonCustom, { validationObject } from '../../../../../../hooks/form_validation_hook'
import { useRESTapi } from '../../../../../../hooks/rest_API'
import { RootState } from '../../../../../../redux/store'
import { StockKeys, pagination } from '../../../../../../types'
import { StockResponse } from '../page'
import { Button } from '@/src/components/ui/button'


type StockOverview = {
    quantity: number,
}


export function AddAdjustmentModal(
    {
        show,
        closeModal,
        id,
        updateUi,
        mode,
        setShow
    }:
        {
            show: boolean,
            closeModal: () => void,
            id?: string,
            updateUi: () => void,
            mode: 'add' | 'edit',
            setShow: (show: boolean) => any
        }
) {

    const [loading, set_loading] = useState(false)

    const validationObject = {
        quantity: {
            message: '',
            validation: [
                (value) => {

                    if (!value) {
                        return 'required'
                    }
                    return true
                }
            ]
        },

    } satisfies validationObject

    const api = useRESTapi();
    const employee = useSelector((state: RootState) => state.employee)
    const [formData, setFormData] = useState<StockOverview>({
        quantity: 0
    })
    // const [isLoading, setIsLoading] = useState(false)
    const { performAllValidation, performValidationOf, errorData, setErrorData } = useFormValidatonCustom<StockOverview>({
        validationObject: validationObject
    })

    const [warehouse_loaded, set_warehouse_loaded] = useState(false)
    const [isLoading, setIsLoading] = useState(false)




    async function handleChangeInput(e: React.ChangeEvent<HTMLInputElement>) {

        let formdata: StockOverview = formData;

        switch (e.target.name) {



            case 'quantity':
                if (e.target.value) {
                    formdata.quantity = e.target.value as any as number
                }

                break;
            default:
                formdata = {
                    ...formdata,
                    [e.target.name]: e.target.value
                }
                break;
        }




        setFormData(formdata)
        performValidationOf(e.target.name, formdata)
        console.log(formdata)

    }





    const load_warehouse = async () => {

        const res = await api.get<{
            success: boolean, data: StockOverview
        }>({
            url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/actual_stock/${id}`,
            mode: 'admin',

        })

        if (res.data.success === true) {
            setFormData(res.data.data)
        } else {
            throw res.data
        }
    }



    const clear_form = () => {
        setFormData({
            quantity: '' as any
        })
        if (mode === 'add') {
            set_warehouse_loaded(false);
        } else {
            set_warehouse_loaded(true)
        }
        setIsLoading(false)
        setErrorData({})

    }

    async function add_actual_stock() {

        setIsLoading(true)
        if (performAllValidation(formData) === true) {


            try {




                const res = await api.put<{ success: boolean, data: any, errors: any, message: string }>({
                    url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/stock_adjustment`,
                    body: {
                        stockId: Number(id),
                        quantity: Number(formData.quantity)
                    },
                    mode: 'admin',

                })

                if (res.data.success === true) {
                    updateUi();
                    alert(res.data.message)
                    closeModal()

                } else {
                    alert(res.data?.message || 'something went wrong')
                    if (res.data.errors) {

                        const errs = res.data.errors;
                        const errData: any = {}

                        for (const key in errs) {
                            errData[key] = errs[key][0]
                        }

                        setErrorData(errData)

                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
        setIsLoading(false)

    }

    useEffect(
        () => {

            const initListSetup = () => {
                // set_loading(true)
                clear_form()
                set_loading(false)


            }
            const initEditSetup = () => {
                set_loading(true)
                clear_form()
                Promise.all(
                    [load_warehouse()]
                ).then(
                    () => {
                        set_loading(false)

                    }
                ).catch(
                    (err) => {
                        console.log(err)
                        set_loading(false)

                    }
                )
                // set_loading(false)


            }

            if (mode === 'add' && show === true) {
                setErrorData({})
                initListSetup()
            } else if (mode === 'edit' && show === true) {
                initEditSetup()
            } else {
                clear_form()
                set_loading(true)

            }


        }, [show]
    )



    return (
        <AdminModal
            show={show}
            setShow={setShow}

        >
            <AdminModalContent  >
                {
                    < >
                        {/* <div onClick={closeModal} className=" absolute right-0 top-0 p-1 cursor-pointer"><IconX /></div> */}
                        <AdminModalHeader>
                            <AdminModalTitle>{mode === 'edit' ? 'Edit Stock' : 'Add Stock'}</AdminModalTitle>
                        </AdminModalHeader>
                        <AdminModalMiddle>



                            <div>Quantity</div>
                            <Input disabled={isLoading === true } value={formData.quantity} onChange={handleChangeInput} type="number" name={'quantity'} placeholder='quantity' />
                            <div className=' text-red-500'>{errorData.quantity ? errorData.quantity : null}</div>


                        </AdminModalMiddle>

                        <AdminModalFooter>
                            <Button disabled={isLoading} onClick={add_actual_stock} >{isLoading ? 'adding...' : 'Add'}</Button>

                        </AdminModalFooter>
                    </>
                }
            </AdminModalContent>
        </AdminModal>
    )
}
